// This file is auto-generated. Do not edit directly.
export const APP_VERSION = '1.1.4';
